import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import _ from 'lodash';

import { TrendingFacetsModel } from '../../../shared';

import { AlgoliaAnalyticsService } from '../../../shared/services/algolia-analytics/algolia-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class TrendingCategoriesService {
  constructor(private algoliaAnalyticsService: AlgoliaAnalyticsService) {}

  public getTrendingCategories(): Observable<string[]> {
    return this.algoliaAnalyticsService.getTrending(`touchPoint`, 10).pipe(
      map((touchPoint: TrendingFacetsModel[]): string[] => {
        return _.map(touchPoint.values, 'value');
      })
    );
  }
}
